import { render, staticRenderFns } from "./DocumentTemplates.vue?vue&type=template&id=dbbe98f4&scoped=true&"
import script from "./DocumentTemplates.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplates.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTemplates.vue?vue&type=style&index=0&id=dbbe98f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbe98f4",
  null
  
)

export default component.exports